import Link from "@/components/ui/Link";
import { Fragment, type HTMLAttributes } from "react";
import { firstUpper } from "./utils";
import { getGalleryUrl } from "@/lib/gallery";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import { getBlogUrl } from "@/lib/blog";

interface BreadCrumbsProps extends HTMLAttributes<HTMLDivElement> {
  hideOnHomepage?: boolean;
  segments: {
    title: string;
    url?: string;
  }[];
}

export default function BreadCrumbs({
  segments,
  className,
  hideOnHomepage,
}: BreadCrumbsProps) {
  const pathName = usePathname();
  const isGallery = pathName?.startsWith(getGalleryUrl());
  const isBlog = pathName?.startsWith(getBlogUrl());

  if (hideOnHomepage && (pathName === "/" || pathName?.includes("/home"))) {
    return null;
  }

  return (
    <div className={cn(`mb-6 block`, className)}>
      <a href="/" className="hover:underline">
        Home
      </a>
      {" / "}
      {isGallery && (
        <Link href={getGalleryUrl()} className="hover:underline">
          Gallery
        </Link>
      )}
      {isBlog && (
        <Link href={getBlogUrl()} className="hover:underline">
          Blog
        </Link>
      )}
      {(isGallery || isBlog) && " / "}
      {segments?.map((segment, index) => {
        return (
          <Fragment key={segment.title}>
            {segment.url ? (
              <Link href={segment.url} className="hover:underline">
                {firstUpper(segment.title)}
              </Link>
            ) : (
              <span>{firstUpper(segment.title)}</span>
            )}
            {index < segments.length - 1 && " / "}
          </Fragment>
        );
      })}
    </div>
  );
}
